import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Panel } from "./Panel";
import { type PanelDataProps, panelDataSchema } from "./Panel.schema";
import { PANEL_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [PANEL_TAG_NAME]: { props: PanelDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-panel": HTMLElement;
  }
}

function RWCPanel({
  width,
  padding,
  margin,
  border,
  overflow,
  color,
}: PanelDataProps): JSX.Element {
  return (
    <Panel
      width={width}
      padding={padding}
      margin={margin}
      border={border}
      overflow={overflow}
      color={color}
    >
      <slot />
    </Panel>
  );
}

componentManager.register(
  rwc(PANEL_TAG_NAME, {
    component: RWCPanel,
    dataSchema: panelDataSchema,
    usesSlots: true,
  }),
);
